import{a as e}from"./chunk-EVTSQNBU.js";import{a as m}from"./chunk-6AAYEFVP.js";import{n as o,o as r}from"./chunk-5NG2JD2X.js";var i=new o({locale:[e,m,r]});export{i as a};
